import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { setMinLeafCount, setVerificationTier } from "../../actions/filters";
import useEvent from "../../hooks/useEvent";
import "./FilterChips.css";

const FilterChips = ({
  minLeafCount,
  verificationTier,
  setMinLeafCount,
  setVerificationTier,
}) => {
  const navigate = useNavigate();
  const location = useLocation();
  const eventContext = useEvent();

  // Helper: update a URL param and navigate
  const updateUrlParam = (key, value) => {
    const params = new URLSearchParams(location.search);
    if (value !== null && value !== undefined) {
      params.set(key, value.toString());
    } else {
      params.delete(key);
    }
    navigate(`?${params.toString()}`);
  };

  const handleLeafCountClick = (value) => {
    // Toggle off if clicking the same value
    const newValue = minLeafCount === value ? null : value;
    setMinLeafCount(newValue);
    updateUrlParam("minLeaf", newValue);
  };

  const handleVerificationClick = (value) => {
    // Toggle off if clicking the same value
    const newValue = verificationTier === value ? null : value;
    setVerificationTier(newValue);
    updateUrlParam("tier", newValue);
  };

  // Hide leaf/verification filters for events - all event restaurants should be on equal footing
  const isEvent = !!eventContext?.event;

  if (isEvent) {
    return null;
  }

  return (
    <div className="filter-chips-container">
      <div className="filter-chips-group">
        <span className="filter-chips-label">Leaves:</span>
        <button
          className={`filter-chip ${minLeafCount === null ? "filter-chip-selected" : ""}`}
          onClick={() => handleLeafCountClick(null)}
          aria-pressed={minLeafCount === null}
        >
          Any
        </button>
        <button
          className={`filter-chip ${minLeafCount === 2 ? "filter-chip-selected" : ""}`}
          onClick={() => handleLeafCountClick(2)}
          aria-pressed={minLeafCount === 2}
        >
          2+
        </button>
        <button
          className={`filter-chip ${minLeafCount === 3 ? "filter-chip-selected" : ""}`}
          onClick={() => handleLeafCountClick(3)}
          aria-pressed={minLeafCount === 3}
        >
          3
        </button>
      </div>

      <div className="filter-chips-group">
        <span className="filter-chips-label">Verification:</span>
        <button
          className={`filter-chip ${verificationTier === null ? "filter-chip-selected" : ""}`}
          onClick={() => handleVerificationClick(null)}
          aria-pressed={verificationTier === null}
        >
          All
        </button>
        <button
          className={`filter-chip ${verificationTier === "guaranteed" ? "filter-chip-selected" : ""}`}
          onClick={() => handleVerificationClick("guaranteed")}
          aria-pressed={verificationTier === "guaranteed"}
          title="Confirmed vegan options"
        >
          <i className="fas fa-check" aria-hidden="true" />
        </button>
        <button
          className={`filter-chip ${verificationTier === "verified" ? "filter-chip-selected" : ""}`}
          onClick={() => handleVerificationClick("verified")}
          aria-pressed={verificationTier === "verified"}
          title="Restaurant-verified vegan options"
        >
          <i className="fas fa-star" aria-hidden="true" />
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  minLeafCount: state.filters.minLeafCount,
  verificationTier: state.filters.verificationTier,
});

export default connect(mapStateToProps, {
  setMinLeafCount,
  setVerificationTier,
})(FilterChips);
